// extracted by mini-css-extract-plugin
export default {"logoContainer":"Logo-module__logoContainer--OUMSc","logo":"Logo-module__logo--uKM0m","logoText":"Logo-module__logoText--s98PA"};